import React from 'react'
import Image from 'next/image'

import { ErrorPageWrapper } from '~/components/ErrorPageWrapper'
import { getLogoUrlForTheme } from '~/utils/assets'
import { isProduction } from '~/utils/envChecks'

import logo from '~/public/assets/iag-loyalty-logo.png'
import { ErrorBoundaryPageProps } from './ErrorBoundary.types'

const ErrorPage = ({ themeId, error, reset }: ErrorBoundaryPageProps) => {
  const siteLogo = themeId ? getLogoUrlForTheme(themeId) : logo
  const isProd = isProduction()

  return (
    <>
      <ErrorPageWrapper
        title={
          <>
            <span style={{ paddingRight: '1rem' }}>{String.fromCharCode(9888)} </span>
            Our website is currently unavailable
          </>
        }
        themeId={themeId}
      >
        <p>Our team is working to bring it back up as soon as possible.</p>

        {!isProd ? (
          <>
            <h2>Developer Message</h2>
            <div role="alert">
              <p style={{ textAlign: 'left' }}>
                More details in available DataDog
                <details>{error.message}</details>
              </p>
            </div>
          </>
        ) : null}

        <Image alt="logo" src={siteLogo} width={200} height={70} />
      </ErrorPageWrapper>
      <script src="" async defer />
    </>
  )
}

export default ErrorPage
